<template>
  <i :class="icon"></i>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    icon: {
      type: Array,
      required: true,
    },
  },
};
</script>
